const o = "_footer_15ftd_1", t = "_wrapper_15ftd_9", n = "_innerWrapper_15ftd_15", r = "_linkList_15ftd_27", _ = "_columnTitle_15ftd_32", a = "_columnFive_15ftd_36", p = "_bottomArea_15ftd_39", e = "_logoWrapper_15ftd_53", i = "_logo_15ftd_53", c = "_appLogos_15ftd_61", d = "_additionalInfoWrapper_15ftd_66", s = "_additionalInfo_15ftd_66", l = "_contactWrapper_15ftd_93", f = "_importantLinks_15ftd_109", m = {
  footer: o,
  wrapper: t,
  innerWrapper: n,
  linkList: r,
  columnTitle: _,
  columnFive: a,
  bottomArea: p,
  logoWrapper: e,
  logo: i,
  appLogos: c,
  additionalInfoWrapper: d,
  additionalInfo: s,
  contactWrapper: l,
  importantLinks: f
};
export {
  s as additionalInfo,
  d as additionalInfoWrapper,
  c as appLogos,
  p as bottomArea,
  a as columnFive,
  _ as columnTitle,
  l as contactWrapper,
  m as default,
  o as footer,
  f as importantLinks,
  n as innerWrapper,
  r as linkList,
  i as logo,
  e as logoWrapper,
  t as wrapper
};
